import { render } from "./Sizes.vue?vue&type=template&id=7dfbdb8b"
import script from "./Sizes.vue?vue&type=script&lang=ts"
export * from "./Sizes.vue?vue&type=script&lang=ts"
script.render = render

export default script